/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onCreateAccessRequest = /* GraphQL */ `
  subscription OnCreateAccessRequest(
    $filter: ModelSubscriptionAccessRequestFilterInput
    $owner: String
  ) {
    onCreateAccessRequest(filter: $filter, owner: $owner) {
      adminNotes
      createdAt
      description
      email
      id
      owner
      status
      updatedAt
      __typename
    }
  }
`;
export const onCreateAgentSchedule = /* GraphQL */ `
  subscription OnCreateAgentSchedule(
    $filter: ModelSubscriptionAgentScheduleFilterInput
    $owner: String
  ) {
    onCreateAgentSchedule(filter: $filter, owner: $owner) {
      createdAt
      cronExpression
      description
      error
      id
      lastRunAt
      metadata
      nextRunAt
      organizationId
      owner
      projectId
      runCount
      runners {
        nextToken
        __typename
      }
      runs {
        nextToken
        __typename
      }
      runtime
      status
      systemPrompt
      timezone
      title
      updatedAt
      __typename
    }
  }
`;
export const onCreateAgentScheduleRun = /* GraphQL */ `
  subscription OnCreateAgentScheduleRun(
    $filter: ModelSubscriptionAgentScheduleRunFilterInput
    $owner: String
  ) {
    onCreateAgentScheduleRun(filter: $filter, owner: $owner) {
      conversations {
        nextToken
        __typename
      }
      createdAt
      error
      id
      organizationId
      owner
      schedule {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      scheduleId
      status
      updatedAt
      __typename
    }
  }
`;
export const onCreateAgentScheduleRunner = /* GraphQL */ `
  subscription OnCreateAgentScheduleRunner(
    $filter: ModelSubscriptionAgentScheduleRunnerFilterInput
    $owner: String
  ) {
    onCreateAgentScheduleRunner(filter: $filter, owner: $owner) {
      attachments
      conversations {
        nextToken
        __typename
      }
      createdAt
      emailCondition
      emailConditionMode
      id
      organizationId
      owner
      prompt
      schedule {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      scheduleId
      sendEmail
      sortOrder
      title
      updatedAt
      __typename
    }
  }
`;
export const onCreateAssetGroup = /* GraphQL */ `
  subscription OnCreateAssetGroup(
    $filter: ModelSubscriptionAssetGroupFilterInput
    $owner: String
  ) {
    onCreateAssetGroup(filter: $filter, owner: $owner) {
      assets {
        nextToken
        __typename
      }
      createdAt
      description
      displayedChannels
      id
      linkedProcessedModelSchemas {
        nextToken
        __typename
      }
      name
      organizationId
      owner
      profilePictureUrl
      updatedAt
      userAssetGroupsId
      __typename
    }
  }
`;
export const onCreateComposedForecast = /* GraphQL */ `
  subscription OnCreateComposedForecast(
    $filter: ModelSubscriptionComposedForecastFilterInput
    $owner: String
  ) {
    onCreateComposedForecast(filter: $filter, owner: $owner) {
      aggregationMethod
      createdAt
      dataSources {
        nextToken
        __typename
      }
      description
      forecastHorizon
      forecastType
      id
      isActive
      lastProcessed
      linkedAssets {
        nextToken
        __typename
      }
      name
      organizationId
      outputParameters
      owner
      processingSchedule
      updateFrequency
      updatedAt
      validationThresholds
      __typename
    }
  }
`;
export const onCreateComposedForecastAssets = /* GraphQL */ `
  subscription OnCreateComposedForecastAssets(
    $filter: ModelSubscriptionComposedForecastAssetsFilterInput
    $owner: String
  ) {
    onCreateComposedForecastAssets(filter: $filter, owner: $owner) {
      asset {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      assetID
      composedForecast {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      composedForecastID
      createdAt
      icon
      id
      isDefault
      organizationId
      owner
      updatedAt
      __typename
    }
  }
`;
export const onCreateComposedForecastDataSource = /* GraphQL */ `
  subscription OnCreateComposedForecastDataSource(
    $filter: ModelSubscriptionComposedForecastDataSourceFilterInput
    $owner: String
  ) {
    onCreateComposedForecastDataSource(filter: $filter, owner: $owner) {
      composedForecast {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      composedForecastId
      createdAt
      dataOperations
      dataQualityScore
      externalApiEndpoint
      externalApiHeaders
      externalApiKey
      externalApiParams
      fallbackStrategy
      fallbackValue
      fetchErrorMessage
      groundTruthSensorId
      groundTruthTableName
      id
      isActive
      lastFetchStatus
      lastFetchedAt
      metadata
      modelOutputTimeOffset
      organizationId
      owner
      postgresAggregation
      postgresColumns
      postgresQuery
      postgresTable
      postgresTimeRange
      priority
      processedModelOutput {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      processedModelOutputId
      projectId
      s3FileFormat
      s3Location
      s3ParseConfig
      sourceDescription
      sourceName
      sourceType
      temporalResolution
      timeAlignment
      timeLag
      transformations
      updatedAt
      validationRules
      weight
      zarrCoordinates
      zarrPath
      zarrTimeSelection
      zarrVariable
      __typename
    }
  }
`;
export const onCreateDataSetRecord = /* GraphQL */ `
  subscription OnCreateDataSetRecord(
    $filter: ModelSubscriptionDataSetRecordFilterInput
    $owner: String
  ) {
    onCreateDataSetRecord(filter: $filter, owner: $owner) {
      columns
      compressedSize
      compressionType
      createdAt
      dataset {
        columns
        createdAt
        curationMode
        datasetType
        deletedAt
        description
        duplicatePolicy
        fileFormat
        fileSize
        id
        ingestMetadata
        lastUpdated
        linkedAssets
        linkedSchemas
        location
        locationId
        name
        organizationId
        owner
        parameterType
        profilePictureUrl
        recordCount
        routeLong
        slug
        sourceModelId
        tags
        timeRange
        units
        updateFrequency
        updatedAt
        userId
        __typename
      }
      datasetId
      fileName
      fileSize
      id
      organizationId
      owner
      recordCount
      s3Path
      timeRange
      timeValue
      updatedAt
      uploadId
      uploadedAt
      uploadedBy
      uploadedByEmail
      __typename
    }
  }
`;
export const onCreateDataSource = /* GraphQL */ `
  subscription OnCreateDataSource(
    $filter: ModelSubscriptionDataSourceFilterInput
    $owner: String
  ) {
    onCreateDataSource(filter: $filter, owner: $owner) {
      createdAt
      dataOperations
      databaseTable
      format
      id
      isGroundTruth
      metadata
      name
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaId
      s3Path
      sourceType
      updatedAt
      __typename
    }
  }
`;
export const onCreateDataset = /* GraphQL */ `
  subscription OnCreateDataset(
    $filter: ModelSubscriptionDatasetFilterInput
    $owner: String
  ) {
    onCreateDataset(filter: $filter, owner: $owner) {
      columns
      createdAt
      curationMode
      datasetType
      deletedAt
      description
      duplicatePolicy
      fileFormat
      fileSize
      id
      ingestMetadata
      lastUpdated
      linkedAssets
      linkedSchemas
      location
      locationId
      name
      organizationId
      owner
      parameterType
      profilePictureUrl
      recordCount
      records {
        nextToken
        __typename
      }
      routeLong
      slug
      sourceModelId
      tags
      timeRange
      units
      updateFrequency
      updatedAt
      userId
      __typename
    }
  }
`;
export const onCreateDatasetUpload = /* GraphQL */ `
  subscription OnCreateDatasetUpload(
    $filter: ModelSubscriptionDatasetUploadFilterInput
    $owner: String
  ) {
    onCreateDatasetUpload(filter: $filter, owner: $owner) {
      columnMetadata
      columnSources
      columns
      createdAt
      datasetId
      duplicateTimestamps
      failureReason
      fileName
      id
      incomingKey
      inputsReadAt
      organizationId
      outputParamId
      owner
      processedAt
      processedModelSchemaId
      rawKey
      receivedAt
      recordId
      rejectedKey
      requestedAt
      rowCount
      runId
      sizeBytes
      source
      sourceTimezone
      status
      timeRange
      updatedAt
      uploadedBy
      uploadedByEmail
      validationErrors
      warnings
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const onCreateErrorLog = /* GraphQL */ `
  subscription OnCreateErrorLog(
    $filter: ModelSubscriptionErrorLogFilterInput
    $owner: String
  ) {
    onCreateErrorLog(filter: $filter, owner: $owner) {
      adminNotes
      cognitoIdentityId
      createdAt
      description
      id
      images
      mcpConversationId
      mcpMessageId
      owner
      pageUrl
      source
      status
      updatedAt
      userEmail
      __typename
    }
  }
`;
export const onCreateForecastRecord = /* GraphQL */ `
  subscription OnCreateForecastRecord(
    $filter: ModelSubscriptionForecastRecordFilterInput
    $owner: String
  ) {
    onCreateForecastRecord(filter: $filter, owner: $owner) {
      createdAt
      forecastIssued
      id
      inputs
      metadata
      organizationId
      owner
      parameter {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      parameterId
      run {
        acknowledged
        acknowledgedAt
        acknowledgedBy
        attempt
        completedAt
        createdAt
        description
        executionTimeMs
        id
        inputs
        modelSchemaTemplateId
        organizationId
        outputS3Keys
        owner
        processedModelScheduleId
        processedModelSchemaId
        requestId
        startedAt
        status
        triggerType
        updatedAt
        windowEnd
        windowStart
        __typename
      }
      runId
      s3Key
      seriesEnd
      seriesMetaData
      seriesStart
      source
      updatedAt
      uploadId
      uploadedBy
      __typename
    }
  }
`;
export const onCreateForecastReport = /* GraphQL */ `
  subscription OnCreateForecastReport(
    $filter: ModelSubscriptionForecastReportFilterInput
    $owner: String
  ) {
    onCreateForecastReport(filter: $filter, owner: $owner) {
      completedAt
      config
      createdAt
      description
      error
      id
      identityId
      name
      organizationId
      owner
      progress
      resultS3Key
      startedAt
      status
      summary
      updatedAt
      __typename
    }
  }
`;
export const onCreateForecastUpload = /* GraphQL */ `
  subscription OnCreateForecastUpload(
    $filter: ModelSubscriptionForecastUploadFilterInput
    $owner: String
  ) {
    onCreateForecastUpload(filter: $filter, owner: $owner) {
      createdAt
      failureReason
      fileName
      finalKey
      forecastIssued
      forecastRecordId
      id
      incomingKey
      issueTime
      organizationId
      outputParamId
      owner
      parameters
      processedAt
      rawKey
      receivedAt
      requestedAt
      rowCount
      schemaId
      sizeBytes
      source
      status
      timeRange
      updatedAt
      uploadedBy
      uploadedByEmail
      validationErrors
      warnings
      __typename
    }
  }
`;
export const onCreateGeoPoint = /* GraphQL */ `
  subscription OnCreateGeoPoint(
    $filter: ModelSubscriptionGeoPointFilterInput
    $owner: String
  ) {
    onCreateGeoPoint(filter: $filter, owner: $owner) {
      assetGroupId
      client
      createdAt
      description
      displayedChannels
      elevation
      geojson
      icon
      id
      imageUrl
      lat
      linkedComposedForecasts {
        nextToken
        __typename
      }
      linkedProcessedModelSchemas {
        nextToken
        __typename
      }
      lng
      name
      organizationId
      owner
      precipCurve {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      precipCurveId
      processedModels {
        nextToken
        __typename
      }
      solarCurve {
        acCap
        arrayAzimuth
        arrayTilt
        createdAt
        dcCap
        description
        groundCoverRatio
        id
        maxTilt
        minIrradiance
        name
        owner
        panelEfficiency
        thermalLoss
        trackingType
        updatedAt
        xUnit
        yUnit
        __typename
      }
      solarCurveId
      tags
      updatedAt
      userGeoPointsId
      value {
        currency
        value
        __typename
      }
      windCurve {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      windCurveId
      __typename
    }
  }
`;
export const onCreateLlmResponse = /* GraphQL */ `
  subscription OnCreateLlmResponse(
    $filter: ModelSubscriptionLlmResponseFilterInput
    $owner: String
  ) {
    onCreateLlmResponse(filter: $filter, owner: $owner) {
      conversation
      createdAt
      description
      executionTime
      id
      owner
      queryType
      response
      updatedAt
      uploadURL
      __typename
    }
  }
`;
export const onCreateLlmResponseById = /* GraphQL */ `
  subscription OnCreateLlmResponseById($id: ID!) {
    onCreateLlmResponseById(id: $id) {
      conversation
      createdAt
      description
      executionTime
      id
      owner
      queryType
      response
      updatedAt
      uploadURL
      __typename
    }
  }
`;
export const onCreateLoginAccessCodes = /* GraphQL */ `
  subscription OnCreateLoginAccessCodes(
    $filter: ModelSubscriptionLoginAccessCodesFilterInput
  ) {
    onCreateLoginAccessCodes(filter: $filter) {
      activatedBy
      available
      code
      createdAt
      notes
      recipient
      updatedAt
      __typename
    }
  }
`;
export const onCreateMCPConversation = /* GraphQL */ `
  subscription OnCreateMCPConversation(
    $filter: ModelSubscriptionMCPConversationFilterInput
    $owner: String
  ) {
    onCreateMCPConversation(filter: $filter, owner: $owner) {
      agentScheduleRunId
      agentScheduleRunnerId
      conversationType
      createdAt
      id
      isActive
      lastMessageAt
      messageCount
      messages {
        nextToken
        __typename
      }
      metadata
      model
      modelCodename
      organizationId
      owner
      projectId
      projectTaskId
      title
      totalTokens
      unreadCount
      updatedAt
      __typename
    }
  }
`;
export const onCreateMCPMessage = /* GraphQL */ `
  subscription OnCreateMCPMessage(
    $filter: ModelSubscriptionMCPMessageFilterInput
    $owner: String
  ) {
    onCreateMCPMessage(filter: $filter, owner: $owner) {
      attachments
      content
      conversation {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      conversationId
      createdAt
      enhancedPrompt
      executionTimeMs
      id
      inputTokens
      isUser
      messageRead
      model
      modelCodename
      organizationId
      outputTokens
      owner
      rating
      ratingComment
      rounds
      serverId
      sessionId
      status
      toolsCount
      updatedAt
      __typename
    }
  }
`;
export const onCreateMCPMessageAll = /* GraphQL */ `
  subscription OnCreateMCPMessageAll {
    onCreateMCPMessageAll {
      attachments
      content
      conversation {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      conversationId
      createdAt
      enhancedPrompt
      executionTimeMs
      id
      inputTokens
      isUser
      messageRead
      model
      modelCodename
      organizationId
      outputTokens
      owner
      rating
      ratingComment
      rounds
      serverId
      sessionId
      status
      toolsCount
      updatedAt
      __typename
    }
  }
`;
export const onCreateMCPMessageByConversation = /* GraphQL */ `
  subscription OnCreateMCPMessageByConversation($conversationId: ID!) {
    onCreateMCPMessageByConversation(conversationId: $conversationId) {
      attachments
      content
      conversation {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      conversationId
      createdAt
      enhancedPrompt
      executionTimeMs
      id
      inputTokens
      isUser
      messageRead
      model
      modelCodename
      organizationId
      outputTokens
      owner
      rating
      ratingComment
      rounds
      serverId
      sessionId
      status
      toolsCount
      updatedAt
      __typename
    }
  }
`;
export const onCreateMCPSharedConversation = /* GraphQL */ `
  subscription OnCreateMCPSharedConversation(
    $filter: ModelSubscriptionMCPSharedConversationFilterInput
    $owner: String
  ) {
    onCreateMCPSharedConversation(filter: $filter, owner: $owner) {
      conversationId
      conversationType
      createdAt
      id
      includePrompts
      isActive
      messageId
      organizationId
      owner
      s3Key
      scheduleRunnerId
      scope
      title
      updatedAt
      __typename
    }
  }
`;
export const onCreateMCPUsage = /* GraphQL */ `
  subscription OnCreateMCPUsage(
    $filter: ModelSubscriptionMCPUsageFilterInput
    $userId: String
  ) {
    onCreateMCPUsage(filter: $filter, userId: $userId) {
      createdAt
      id
      period
      requestCount
      subscriptionTier
      tokenLimit
      tokensUsed
      updatedAt
      userId
      __typename
    }
  }
`;
export const onCreateModelSchemaTemplate = /* GraphQL */ `
  subscription OnCreateModelSchemaTemplate(
    $filter: ModelSubscriptionModelSchemaTemplateFilterInput
  ) {
    onCreateModelSchemaTemplate(filter: $filter) {
      authorProfileId
      authorType
      category
      createdAt
      createdBy
      description
      executionUrl
      external
      fieldDefinitions
      historicalConfig
      id
      isActive
      modelKind
      name
      profilePictureUrl
      requiresTraining
      tags
      trainingCost
      updatedAt
      version
      __typename
    }
  }
`;
export const onCreateOrganization = /* GraphQL */ `
  subscription OnCreateOrganization(
    $filter: ModelSubscriptionOrganizationFilterInput
    $owner: String
  ) {
    onCreateOrganization(filter: $filter, owner: $owner) {
      createdAt
      description
      id
      members {
        nextToken
        __typename
      }
      name
      orgAiAnalystAccess
      owner
      profilePictureUrl
      updatedAt
      __typename
    }
  }
`;
export const onCreateOrganizationPublicProfile = /* GraphQL */ `
  subscription OnCreateOrganizationPublicProfile(
    $filter: ModelSubscriptionOrganizationPublicProfileFilterInput
    $owner: String
  ) {
    onCreateOrganizationPublicProfile(filter: $filter, owner: $owner) {
      bio
      createdAt
      displayName
      email
      employees {
        nextToken
        __typename
      }
      id
      owner
      profilePictureUrl
      showBio
      showDisplayName
      showEmail
      showProfilePicture
      updatedAt
      __typename
    }
  }
`;
export const onCreatePerformanceCurve = /* GraphQL */ `
  subscription OnCreatePerformanceCurve(
    $filter: ModelSubscriptionPerformanceCurveFilterInput
    $owner: String
  ) {
    onCreatePerformanceCurve(filter: $filter, owner: $owner) {
      createdAt
      curveData {
        x
        y
        __typename
      }
      description
      id
      name
      organizationId
      organizationIds
      owner
      updatedAt
      xUnit
      yUnit
      __typename
    }
  }
`;
export const onCreateProcessedModel = /* GraphQL */ `
  subscription OnCreateProcessedModel(
    $filter: ModelSubscriptionProcessedModelFilterInput
    $owner: String
  ) {
    onCreateProcessedModel(filter: $filter, owner: $owner) {
      additionalDataPoints {
        color
        id
        lookbackDays
        name
        parameterId
        schema
        source
        __typename
      }
      assetId
      createdAt
      deliveryCron
      deliveryGraceMinutes
      deliveryMatchBy
      deliveryTimezone
      deliveryTrackingStartedAt
      description
      displayType
      geopoint {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      id
      label
      modelType
      organizationId
      owner
      routeLong
      routeShort
      schema
      updatedAt
      __typename
    }
  }
`;
export const onCreateProcessedModelOutputParam = /* GraphQL */ `
  subscription OnCreateProcessedModelOutputParam(
    $filter: ModelSubscriptionProcessedModelOutputParamFilterInput
    $owner: String
  ) {
    onCreateProcessedModelOutputParam(filter: $filter, owner: $owner) {
      active
      channels
      createdAt
      description
      forecasts {
        nextToken
        __typename
      }
      id
      name
      organizationId
      outputLocation
      owner
      parameterTypeId
      schema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      schemaId
      seriesMetaData
      storageMode
      targetDatasetId
      unit
      updatedAt
      __typename
    }
  }
`;
export const onCreateProcessedModelRunHistory = /* GraphQL */ `
  subscription OnCreateProcessedModelRunHistory(
    $filter: ModelSubscriptionProcessedModelRunHistoryFilterInput
    $owner: String
  ) {
    onCreateProcessedModelRunHistory(filter: $filter, owner: $owner) {
      acknowledged
      acknowledgedAt
      acknowledgedBy
      attempt
      completedAt
      createdAt
      description
      executionTimeMs
      forecasts {
        nextToken
        __typename
      }
      id
      inputs
      modelSchemaTemplateId
      organizationId
      outputS3Keys
      owner
      processedModelScheduleId
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaId
      requestId
      startedAt
      status
      triggerType
      updatedAt
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const onCreateProcessedModelRunRequest = /* GraphQL */ `
  subscription OnCreateProcessedModelRunRequest(
    $filter: ModelSubscriptionProcessedModelRunRequestFilterInput
    $owner: String
  ) {
    onCreateProcessedModelRunRequest(filter: $filter, owner: $owner) {
      attempts
      backfillId
      chunkCount
      chunkIndex
      completedAt
      createdAt
      error
      id
      mergedInto
      notBefore
      organizationId
      owner
      processedModelSchemaId
      runIds
      startedAt
      status
      triggerRef
      triggerType
      updatedAt
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const onCreateProcessedModelSchedule = /* GraphQL */ `
  subscription OnCreateProcessedModelSchedule(
    $filter: ModelSubscriptionProcessedModelScheduleFilterInput
    $owner: String
  ) {
    onCreateProcessedModelSchedule(filter: $filter, owner: $owner) {
      createdAt
      cronExpression
      firstRunTime
      frequency
      id
      lastRunAt
      nextRunAt
      organizationId
      owner
      processedModelSchemaId
      runCount
      status
      timezone
      updatedAt
      __typename
    }
  }
`;
export const onCreateProcessedModelSchema = /* GraphQL */ `
  subscription OnCreateProcessedModelSchema(
    $filter: ModelSubscriptionProcessedModelSchemaFilterInput
    $owner: String
  ) {
    onCreateProcessedModelSchema(filter: $filter, owner: $owner) {
      activeStatus
      createdAt
      dataSources {
        nextToken
        __typename
      }
      deliveryExpectation
      dependency
      description
      executionUrl
      historicalSettings
      id
      isActive
      linkedAssetGroups {
        nextToken
        __typename
      }
      linkedAssets {
        nextToken
        __typename
      }
      linkedDatasets {
        nextToken
        __typename
      }
      linkedOutputs {
        nextToken
        __typename
      }
      modelKind
      name
      organizationId
      outputs {
        nextToken
        __typename
      }
      owner
      runHistory {
        nextToken
        __typename
      }
      runSchedule
      s3BasePath
      schemaFields
      schemaType
      type
      updatedAt
      version
      __typename
    }
  }
`;
export const onCreateProcessedModelSchemaAssetGroups = /* GraphQL */ `
  subscription OnCreateProcessedModelSchemaAssetGroups(
    $filter: ModelSubscriptionProcessedModelSchemaAssetGroupsFilterInput
    $owner: String
  ) {
    onCreateProcessedModelSchemaAssetGroups(filter: $filter, owner: $owner) {
      assetGroup {
        createdAt
        description
        displayedChannels
        id
        name
        organizationId
        owner
        profilePictureUrl
        updatedAt
        userAssetGroupsId
        __typename
      }
      assetGroupID
      createdAt
      id
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaID
      updatedAt
      __typename
    }
  }
`;
export const onCreateProcessedModelSchemaAssets = /* GraphQL */ `
  subscription OnCreateProcessedModelSchemaAssets(
    $filter: ModelSubscriptionProcessedModelSchemaAssetsFilterInput
    $owner: String
  ) {
    onCreateProcessedModelSchemaAssets(filter: $filter, owner: $owner) {
      asset {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      assetID
      createdAt
      id
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaID
      updatedAt
      __typename
    }
  }
`;
export const onCreateProcessedModelV1EmailLog = /* GraphQL */ `
  subscription OnCreateProcessedModelV1EmailLog(
    $filter: ModelSubscriptionProcessedModelV1EmailLogFilterInput
  ) {
    onCreateProcessedModelV1EmailLog(filter: $filter) {
      assetCount
      assetNames
      ccRecipientCount
      chartsRendered
      completedAt
      createdAt
      errorMessage
      id
      recipientCount
      scheduleId
      startedAt
      status
      updatedAt
      __typename
    }
  }
`;
export const onCreateProcessedModelV1EmailSchedule = /* GraphQL */ `
  subscription OnCreateProcessedModelV1EmailSchedule(
    $filter: ModelSubscriptionProcessedModelV1EmailScheduleFilterInput
    $owner: String
  ) {
    onCreateProcessedModelV1EmailSchedule(filter: $filter, owner: $owner) {
      ccRecipients
      createdAt
      cronExpression
      firstRunTime
      frequency
      id
      label
      lastRunAt
      nextRunAt
      organizationId
      owner
      recipients
      runCount
      status
      targets {
        assetId
        assetName
        __typename
      }
      timezone
      updatedAt
      __typename
    }
  }
`;
export const onCreatePublicProfile = /* GraphQL */ `
  subscription OnCreatePublicProfile(
    $filter: ModelSubscriptionPublicProfileFilterInput
    $owner: String
  ) {
    onCreatePublicProfile(filter: $filter, owner: $owner) {
      bio
      createdAt
      displayName
      email
      id
      organizationProfileId
      owner
      profilePictureUrl
      showBio
      showDisplayName
      showEmail
      showProfilePicture
      updatedAt
      __typename
    }
  }
`;
export const onCreateSolarEnergyModel = /* GraphQL */ `
  subscription OnCreateSolarEnergyModel(
    $filter: ModelSubscriptionSolarEnergyModelFilterInput
    $owner: String
  ) {
    onCreateSolarEnergyModel(filter: $filter, owner: $owner) {
      acCap
      arrayAzimuth
      arrayTilt
      createdAt
      dcCap
      description
      groundCoverRatio
      id
      maxTilt
      minIrradiance
      name
      owner
      panelEfficiency
      thermalLoss
      trackingType
      updatedAt
      xUnit
      yUnit
      __typename
    }
  }
`;
export const onCreateSystemPrompt = /* GraphQL */ `
  subscription OnCreateSystemPrompt(
    $filter: ModelSubscriptionSystemPromptFilterInput
  ) {
    onCreateSystemPrompt(filter: $filter) {
      createdAt
      description
      id
      isDefault
      model
      promptText
      rating
      surface
      updatedAt
      __typename
    }
  }
`;
export const onCreateUploadData = /* GraphQL */ `
  subscription OnCreateUploadData(
    $filter: ModelSubscriptionUploadDataFilterInput
    $owner: String
  ) {
    onCreateUploadData(filter: $filter, owner: $owner) {
      createdAt
      description
      fileLocation
      id
      name
      objective
      optimizationHorizon
      owner
      parameter
      seasonality
      temporalResolution
      updatedAt
      __typename
    }
  }
`;
export const onCreateUser = /* GraphQL */ `
  subscription OnCreateUser(
    $filter: ModelSubscriptionUserFilterInput
    $username: String
  ) {
    onCreateUser(filter: $filter, username: $username) {
      assetCount
      assetGroupCount
      assetGroups {
        nextToken
        __typename
      }
      chatPrivacyPolicyAccepted
      chatPrivacyPolicyLocation
      cognitoIdentityId
      createdAt
      email
      geoPoints {
        nextToken
        __typename
      }
      id
      name
      organizationIds
      organizations {
        nextToken
        __typename
      }
      personas {
        nextToken
        __typename
      }
      preferredPersona {
        completed
        createdAt
        description
        id
        markets
        name
        owner
        regions
        selectedNeeds
        summary
        updatedAt
        userId
        __typename
      }
      preferredPersonaId
      privacyPolicyAuditTrail
      profilePictureUrl
      termsAndConditionsAuditTrail
      termsAndConditionsLocation
      termsAndConditionsReviewed
      tourAssetSeen
      tourChatCompleted
      tourGroupSeen
      tourOnboardingGuidanceSent
      tourWelcomeShown
      updatedAt
      userConsent
      username
      __typename
    }
  }
`;
export const onCreateUserChecklistProgress = /* GraphQL */ `
  subscription OnCreateUserChecklistProgress(
    $filter: ModelSubscriptionUserChecklistProgressFilterInput
    $owner: String
  ) {
    onCreateUserChecklistProgress(filter: $filter, owner: $owner) {
      createdAt
      hatUnlocked
      id
      loginDates
      owner
      shippingAddress
      step1Complete
      step2Complete
      step3Complete
      step4Complete
      step5Complete
      step6Complete
      updatedAt
      userId
      welcomeShown
      __typename
    }
  }
`;
export const onCreateUserOrganizations = /* GraphQL */ `
  subscription OnCreateUserOrganizations(
    $filter: ModelSubscriptionUserOrganizationsFilterInput
    $owner: String
  ) {
    onCreateUserOrganizations(filter: $filter, owner: $owner) {
      createdAt
      id
      organization {
        createdAt
        description
        id
        name
        orgAiAnalystAccess
        owner
        profilePictureUrl
        updatedAt
        __typename
      }
      organizationId
      owner
      updatedAt
      user {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      userID
      __typename
    }
  }
`;
export const onCreateUserPersona = /* GraphQL */ `
  subscription OnCreateUserPersona(
    $filter: ModelSubscriptionUserPersonaFilterInput
    $owner: String
  ) {
    onCreateUserPersona(filter: $filter, owner: $owner) {
      completed
      createdAt
      description
      id
      markets
      name
      owner
      regions
      selectedNeeds
      summary
      updatedAt
      user {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      userId
      __typename
    }
  }
`;
export const onCreateUserProject = /* GraphQL */ `
  subscription OnCreateUserProject(
    $filter: ModelSubscriptionUserProjectFilterInput
    $owner: String
  ) {
    onCreateUserProject(filter: $filter, owner: $owner) {
      createdAt
      datasetIds
      description
      id
      imageUrl
      organizationId
      owner
      tasks {
        nextToken
        __typename
      }
      title
      updatedAt
      __typename
    }
  }
`;
export const onCreateUserProjectTask = /* GraphQL */ `
  subscription OnCreateUserProjectTask(
    $filter: ModelSubscriptionUserProjectTaskFilterInput
    $owner: String
  ) {
    onCreateUserProjectTask(filter: $filter, owner: $owner) {
      completedTask
      createdAt
      description
      id
      order
      owner
      project {
        createdAt
        datasetIds
        description
        id
        imageUrl
        organizationId
        owner
        title
        updatedAt
        __typename
      }
      projectId
      title
      updatedAt
      __typename
    }
  }
`;
export const onCreateUserSubscription = /* GraphQL */ `
  subscription OnCreateUserSubscription(
    $filter: ModelSubscriptionUserSubscriptionFilterInput
    $owner: String
  ) {
    onCreateUserSubscription(filter: $filter, owner: $owner) {
      cancelAt
      cancelAtPeriodEnd
      createdAt
      currentPeriodEnd
      customerId
      entitlements
      id
      items
      lastPaymentDate
      lastPaymentStatus
      livemode
      owner
      status
      updatedAt
      __typename
    }
  }
`;
export const onCreateUserTokenGrant = /* GraphQL */ `
  subscription OnCreateUserTokenGrant(
    $filter: ModelSubscriptionUserTokenGrantFilterInput
  ) {
    onCreateUserTokenGrant(filter: $filter) {
      active
      createdAt
      email
      expiresAt
      grantedBy
      id
      notes
      tokenLimit
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAccessRequest = /* GraphQL */ `
  subscription OnDeleteAccessRequest(
    $filter: ModelSubscriptionAccessRequestFilterInput
    $owner: String
  ) {
    onDeleteAccessRequest(filter: $filter, owner: $owner) {
      adminNotes
      createdAt
      description
      email
      id
      owner
      status
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAgentSchedule = /* GraphQL */ `
  subscription OnDeleteAgentSchedule(
    $filter: ModelSubscriptionAgentScheduleFilterInput
    $owner: String
  ) {
    onDeleteAgentSchedule(filter: $filter, owner: $owner) {
      createdAt
      cronExpression
      description
      error
      id
      lastRunAt
      metadata
      nextRunAt
      organizationId
      owner
      projectId
      runCount
      runners {
        nextToken
        __typename
      }
      runs {
        nextToken
        __typename
      }
      runtime
      status
      systemPrompt
      timezone
      title
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAgentScheduleRun = /* GraphQL */ `
  subscription OnDeleteAgentScheduleRun(
    $filter: ModelSubscriptionAgentScheduleRunFilterInput
    $owner: String
  ) {
    onDeleteAgentScheduleRun(filter: $filter, owner: $owner) {
      conversations {
        nextToken
        __typename
      }
      createdAt
      error
      id
      organizationId
      owner
      schedule {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      scheduleId
      status
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAgentScheduleRunner = /* GraphQL */ `
  subscription OnDeleteAgentScheduleRunner(
    $filter: ModelSubscriptionAgentScheduleRunnerFilterInput
    $owner: String
  ) {
    onDeleteAgentScheduleRunner(filter: $filter, owner: $owner) {
      attachments
      conversations {
        nextToken
        __typename
      }
      createdAt
      emailCondition
      emailConditionMode
      id
      organizationId
      owner
      prompt
      schedule {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      scheduleId
      sendEmail
      sortOrder
      title
      updatedAt
      __typename
    }
  }
`;
export const onDeleteAssetGroup = /* GraphQL */ `
  subscription OnDeleteAssetGroup(
    $filter: ModelSubscriptionAssetGroupFilterInput
    $owner: String
  ) {
    onDeleteAssetGroup(filter: $filter, owner: $owner) {
      assets {
        nextToken
        __typename
      }
      createdAt
      description
      displayedChannels
      id
      linkedProcessedModelSchemas {
        nextToken
        __typename
      }
      name
      organizationId
      owner
      profilePictureUrl
      updatedAt
      userAssetGroupsId
      __typename
    }
  }
`;
export const onDeleteComposedForecast = /* GraphQL */ `
  subscription OnDeleteComposedForecast(
    $filter: ModelSubscriptionComposedForecastFilterInput
    $owner: String
  ) {
    onDeleteComposedForecast(filter: $filter, owner: $owner) {
      aggregationMethod
      createdAt
      dataSources {
        nextToken
        __typename
      }
      description
      forecastHorizon
      forecastType
      id
      isActive
      lastProcessed
      linkedAssets {
        nextToken
        __typename
      }
      name
      organizationId
      outputParameters
      owner
      processingSchedule
      updateFrequency
      updatedAt
      validationThresholds
      __typename
    }
  }
`;
export const onDeleteComposedForecastAssets = /* GraphQL */ `
  subscription OnDeleteComposedForecastAssets(
    $filter: ModelSubscriptionComposedForecastAssetsFilterInput
    $owner: String
  ) {
    onDeleteComposedForecastAssets(filter: $filter, owner: $owner) {
      asset {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      assetID
      composedForecast {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      composedForecastID
      createdAt
      icon
      id
      isDefault
      organizationId
      owner
      updatedAt
      __typename
    }
  }
`;
export const onDeleteComposedForecastDataSource = /* GraphQL */ `
  subscription OnDeleteComposedForecastDataSource(
    $filter: ModelSubscriptionComposedForecastDataSourceFilterInput
    $owner: String
  ) {
    onDeleteComposedForecastDataSource(filter: $filter, owner: $owner) {
      composedForecast {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      composedForecastId
      createdAt
      dataOperations
      dataQualityScore
      externalApiEndpoint
      externalApiHeaders
      externalApiKey
      externalApiParams
      fallbackStrategy
      fallbackValue
      fetchErrorMessage
      groundTruthSensorId
      groundTruthTableName
      id
      isActive
      lastFetchStatus
      lastFetchedAt
      metadata
      modelOutputTimeOffset
      organizationId
      owner
      postgresAggregation
      postgresColumns
      postgresQuery
      postgresTable
      postgresTimeRange
      priority
      processedModelOutput {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      processedModelOutputId
      projectId
      s3FileFormat
      s3Location
      s3ParseConfig
      sourceDescription
      sourceName
      sourceType
      temporalResolution
      timeAlignment
      timeLag
      transformations
      updatedAt
      validationRules
      weight
      zarrCoordinates
      zarrPath
      zarrTimeSelection
      zarrVariable
      __typename
    }
  }
`;
export const onDeleteDataSetRecord = /* GraphQL */ `
  subscription OnDeleteDataSetRecord(
    $filter: ModelSubscriptionDataSetRecordFilterInput
    $owner: String
  ) {
    onDeleteDataSetRecord(filter: $filter, owner: $owner) {
      columns
      compressedSize
      compressionType
      createdAt
      dataset {
        columns
        createdAt
        curationMode
        datasetType
        deletedAt
        description
        duplicatePolicy
        fileFormat
        fileSize
        id
        ingestMetadata
        lastUpdated
        linkedAssets
        linkedSchemas
        location
        locationId
        name
        organizationId
        owner
        parameterType
        profilePictureUrl
        recordCount
        routeLong
        slug
        sourceModelId
        tags
        timeRange
        units
        updateFrequency
        updatedAt
        userId
        __typename
      }
      datasetId
      fileName
      fileSize
      id
      organizationId
      owner
      recordCount
      s3Path
      timeRange
      timeValue
      updatedAt
      uploadId
      uploadedAt
      uploadedBy
      uploadedByEmail
      __typename
    }
  }
`;
export const onDeleteDataSource = /* GraphQL */ `
  subscription OnDeleteDataSource(
    $filter: ModelSubscriptionDataSourceFilterInput
    $owner: String
  ) {
    onDeleteDataSource(filter: $filter, owner: $owner) {
      createdAt
      dataOperations
      databaseTable
      format
      id
      isGroundTruth
      metadata
      name
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaId
      s3Path
      sourceType
      updatedAt
      __typename
    }
  }
`;
export const onDeleteDataset = /* GraphQL */ `
  subscription OnDeleteDataset(
    $filter: ModelSubscriptionDatasetFilterInput
    $owner: String
  ) {
    onDeleteDataset(filter: $filter, owner: $owner) {
      columns
      createdAt
      curationMode
      datasetType
      deletedAt
      description
      duplicatePolicy
      fileFormat
      fileSize
      id
      ingestMetadata
      lastUpdated
      linkedAssets
      linkedSchemas
      location
      locationId
      name
      organizationId
      owner
      parameterType
      profilePictureUrl
      recordCount
      records {
        nextToken
        __typename
      }
      routeLong
      slug
      sourceModelId
      tags
      timeRange
      units
      updateFrequency
      updatedAt
      userId
      __typename
    }
  }
`;
export const onDeleteDatasetUpload = /* GraphQL */ `
  subscription OnDeleteDatasetUpload(
    $filter: ModelSubscriptionDatasetUploadFilterInput
    $owner: String
  ) {
    onDeleteDatasetUpload(filter: $filter, owner: $owner) {
      columnMetadata
      columnSources
      columns
      createdAt
      datasetId
      duplicateTimestamps
      failureReason
      fileName
      id
      incomingKey
      inputsReadAt
      organizationId
      outputParamId
      owner
      processedAt
      processedModelSchemaId
      rawKey
      receivedAt
      recordId
      rejectedKey
      requestedAt
      rowCount
      runId
      sizeBytes
      source
      sourceTimezone
      status
      timeRange
      updatedAt
      uploadedBy
      uploadedByEmail
      validationErrors
      warnings
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const onDeleteErrorLog = /* GraphQL */ `
  subscription OnDeleteErrorLog(
    $filter: ModelSubscriptionErrorLogFilterInput
    $owner: String
  ) {
    onDeleteErrorLog(filter: $filter, owner: $owner) {
      adminNotes
      cognitoIdentityId
      createdAt
      description
      id
      images
      mcpConversationId
      mcpMessageId
      owner
      pageUrl
      source
      status
      updatedAt
      userEmail
      __typename
    }
  }
`;
export const onDeleteForecastRecord = /* GraphQL */ `
  subscription OnDeleteForecastRecord(
    $filter: ModelSubscriptionForecastRecordFilterInput
    $owner: String
  ) {
    onDeleteForecastRecord(filter: $filter, owner: $owner) {
      createdAt
      forecastIssued
      id
      inputs
      metadata
      organizationId
      owner
      parameter {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      parameterId
      run {
        acknowledged
        acknowledgedAt
        acknowledgedBy
        attempt
        completedAt
        createdAt
        description
        executionTimeMs
        id
        inputs
        modelSchemaTemplateId
        organizationId
        outputS3Keys
        owner
        processedModelScheduleId
        processedModelSchemaId
        requestId
        startedAt
        status
        triggerType
        updatedAt
        windowEnd
        windowStart
        __typename
      }
      runId
      s3Key
      seriesEnd
      seriesMetaData
      seriesStart
      source
      updatedAt
      uploadId
      uploadedBy
      __typename
    }
  }
`;
export const onDeleteForecastReport = /* GraphQL */ `
  subscription OnDeleteForecastReport(
    $filter: ModelSubscriptionForecastReportFilterInput
    $owner: String
  ) {
    onDeleteForecastReport(filter: $filter, owner: $owner) {
      completedAt
      config
      createdAt
      description
      error
      id
      identityId
      name
      organizationId
      owner
      progress
      resultS3Key
      startedAt
      status
      summary
      updatedAt
      __typename
    }
  }
`;
export const onDeleteForecastUpload = /* GraphQL */ `
  subscription OnDeleteForecastUpload(
    $filter: ModelSubscriptionForecastUploadFilterInput
    $owner: String
  ) {
    onDeleteForecastUpload(filter: $filter, owner: $owner) {
      createdAt
      failureReason
      fileName
      finalKey
      forecastIssued
      forecastRecordId
      id
      incomingKey
      issueTime
      organizationId
      outputParamId
      owner
      parameters
      processedAt
      rawKey
      receivedAt
      requestedAt
      rowCount
      schemaId
      sizeBytes
      source
      status
      timeRange
      updatedAt
      uploadedBy
      uploadedByEmail
      validationErrors
      warnings
      __typename
    }
  }
`;
export const onDeleteGeoPoint = /* GraphQL */ `
  subscription OnDeleteGeoPoint(
    $filter: ModelSubscriptionGeoPointFilterInput
    $owner: String
  ) {
    onDeleteGeoPoint(filter: $filter, owner: $owner) {
      assetGroupId
      client
      createdAt
      description
      displayedChannels
      elevation
      geojson
      icon
      id
      imageUrl
      lat
      linkedComposedForecasts {
        nextToken
        __typename
      }
      linkedProcessedModelSchemas {
        nextToken
        __typename
      }
      lng
      name
      organizationId
      owner
      precipCurve {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      precipCurveId
      processedModels {
        nextToken
        __typename
      }
      solarCurve {
        acCap
        arrayAzimuth
        arrayTilt
        createdAt
        dcCap
        description
        groundCoverRatio
        id
        maxTilt
        minIrradiance
        name
        owner
        panelEfficiency
        thermalLoss
        trackingType
        updatedAt
        xUnit
        yUnit
        __typename
      }
      solarCurveId
      tags
      updatedAt
      userGeoPointsId
      value {
        currency
        value
        __typename
      }
      windCurve {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      windCurveId
      __typename
    }
  }
`;
export const onDeleteLlmResponse = /* GraphQL */ `
  subscription OnDeleteLlmResponse(
    $filter: ModelSubscriptionLlmResponseFilterInput
    $owner: String
  ) {
    onDeleteLlmResponse(filter: $filter, owner: $owner) {
      conversation
      createdAt
      description
      executionTime
      id
      owner
      queryType
      response
      updatedAt
      uploadURL
      __typename
    }
  }
`;
export const onDeleteLoginAccessCodes = /* GraphQL */ `
  subscription OnDeleteLoginAccessCodes(
    $filter: ModelSubscriptionLoginAccessCodesFilterInput
  ) {
    onDeleteLoginAccessCodes(filter: $filter) {
      activatedBy
      available
      code
      createdAt
      notes
      recipient
      updatedAt
      __typename
    }
  }
`;
export const onDeleteMCPConversation = /* GraphQL */ `
  subscription OnDeleteMCPConversation(
    $filter: ModelSubscriptionMCPConversationFilterInput
    $owner: String
  ) {
    onDeleteMCPConversation(filter: $filter, owner: $owner) {
      agentScheduleRunId
      agentScheduleRunnerId
      conversationType
      createdAt
      id
      isActive
      lastMessageAt
      messageCount
      messages {
        nextToken
        __typename
      }
      metadata
      model
      modelCodename
      organizationId
      owner
      projectId
      projectTaskId
      title
      totalTokens
      unreadCount
      updatedAt
      __typename
    }
  }
`;
export const onDeleteMCPMessage = /* GraphQL */ `
  subscription OnDeleteMCPMessage(
    $filter: ModelSubscriptionMCPMessageFilterInput
    $owner: String
  ) {
    onDeleteMCPMessage(filter: $filter, owner: $owner) {
      attachments
      content
      conversation {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      conversationId
      createdAt
      enhancedPrompt
      executionTimeMs
      id
      inputTokens
      isUser
      messageRead
      model
      modelCodename
      organizationId
      outputTokens
      owner
      rating
      ratingComment
      rounds
      serverId
      sessionId
      status
      toolsCount
      updatedAt
      __typename
    }
  }
`;
export const onDeleteMCPSharedConversation = /* GraphQL */ `
  subscription OnDeleteMCPSharedConversation(
    $filter: ModelSubscriptionMCPSharedConversationFilterInput
    $owner: String
  ) {
    onDeleteMCPSharedConversation(filter: $filter, owner: $owner) {
      conversationId
      conversationType
      createdAt
      id
      includePrompts
      isActive
      messageId
      organizationId
      owner
      s3Key
      scheduleRunnerId
      scope
      title
      updatedAt
      __typename
    }
  }
`;
export const onDeleteMCPUsage = /* GraphQL */ `
  subscription OnDeleteMCPUsage(
    $filter: ModelSubscriptionMCPUsageFilterInput
    $userId: String
  ) {
    onDeleteMCPUsage(filter: $filter, userId: $userId) {
      createdAt
      id
      period
      requestCount
      subscriptionTier
      tokenLimit
      tokensUsed
      updatedAt
      userId
      __typename
    }
  }
`;
export const onDeleteModelSchemaTemplate = /* GraphQL */ `
  subscription OnDeleteModelSchemaTemplate(
    $filter: ModelSubscriptionModelSchemaTemplateFilterInput
  ) {
    onDeleteModelSchemaTemplate(filter: $filter) {
      authorProfileId
      authorType
      category
      createdAt
      createdBy
      description
      executionUrl
      external
      fieldDefinitions
      historicalConfig
      id
      isActive
      modelKind
      name
      profilePictureUrl
      requiresTraining
      tags
      trainingCost
      updatedAt
      version
      __typename
    }
  }
`;
export const onDeleteOrganization = /* GraphQL */ `
  subscription OnDeleteOrganization(
    $filter: ModelSubscriptionOrganizationFilterInput
    $owner: String
  ) {
    onDeleteOrganization(filter: $filter, owner: $owner) {
      createdAt
      description
      id
      members {
        nextToken
        __typename
      }
      name
      orgAiAnalystAccess
      owner
      profilePictureUrl
      updatedAt
      __typename
    }
  }
`;
export const onDeleteOrganizationPublicProfile = /* GraphQL */ `
  subscription OnDeleteOrganizationPublicProfile(
    $filter: ModelSubscriptionOrganizationPublicProfileFilterInput
    $owner: String
  ) {
    onDeleteOrganizationPublicProfile(filter: $filter, owner: $owner) {
      bio
      createdAt
      displayName
      email
      employees {
        nextToken
        __typename
      }
      id
      owner
      profilePictureUrl
      showBio
      showDisplayName
      showEmail
      showProfilePicture
      updatedAt
      __typename
    }
  }
`;
export const onDeletePerformanceCurve = /* GraphQL */ `
  subscription OnDeletePerformanceCurve(
    $filter: ModelSubscriptionPerformanceCurveFilterInput
    $owner: String
  ) {
    onDeletePerformanceCurve(filter: $filter, owner: $owner) {
      createdAt
      curveData {
        x
        y
        __typename
      }
      description
      id
      name
      organizationId
      organizationIds
      owner
      updatedAt
      xUnit
      yUnit
      __typename
    }
  }
`;
export const onDeleteProcessedModel = /* GraphQL */ `
  subscription OnDeleteProcessedModel(
    $filter: ModelSubscriptionProcessedModelFilterInput
    $owner: String
  ) {
    onDeleteProcessedModel(filter: $filter, owner: $owner) {
      additionalDataPoints {
        color
        id
        lookbackDays
        name
        parameterId
        schema
        source
        __typename
      }
      assetId
      createdAt
      deliveryCron
      deliveryGraceMinutes
      deliveryMatchBy
      deliveryTimezone
      deliveryTrackingStartedAt
      description
      displayType
      geopoint {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      id
      label
      modelType
      organizationId
      owner
      routeLong
      routeShort
      schema
      updatedAt
      __typename
    }
  }
`;
export const onDeleteProcessedModelOutputParam = /* GraphQL */ `
  subscription OnDeleteProcessedModelOutputParam(
    $filter: ModelSubscriptionProcessedModelOutputParamFilterInput
    $owner: String
  ) {
    onDeleteProcessedModelOutputParam(filter: $filter, owner: $owner) {
      active
      channels
      createdAt
      description
      forecasts {
        nextToken
        __typename
      }
      id
      name
      organizationId
      outputLocation
      owner
      parameterTypeId
      schema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      schemaId
      seriesMetaData
      storageMode
      targetDatasetId
      unit
      updatedAt
      __typename
    }
  }
`;
export const onDeleteProcessedModelRunHistory = /* GraphQL */ `
  subscription OnDeleteProcessedModelRunHistory(
    $filter: ModelSubscriptionProcessedModelRunHistoryFilterInput
    $owner: String
  ) {
    onDeleteProcessedModelRunHistory(filter: $filter, owner: $owner) {
      acknowledged
      acknowledgedAt
      acknowledgedBy
      attempt
      completedAt
      createdAt
      description
      executionTimeMs
      forecasts {
        nextToken
        __typename
      }
      id
      inputs
      modelSchemaTemplateId
      organizationId
      outputS3Keys
      owner
      processedModelScheduleId
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaId
      requestId
      startedAt
      status
      triggerType
      updatedAt
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const onDeleteProcessedModelRunRequest = /* GraphQL */ `
  subscription OnDeleteProcessedModelRunRequest(
    $filter: ModelSubscriptionProcessedModelRunRequestFilterInput
    $owner: String
  ) {
    onDeleteProcessedModelRunRequest(filter: $filter, owner: $owner) {
      attempts
      backfillId
      chunkCount
      chunkIndex
      completedAt
      createdAt
      error
      id
      mergedInto
      notBefore
      organizationId
      owner
      processedModelSchemaId
      runIds
      startedAt
      status
      triggerRef
      triggerType
      updatedAt
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const onDeleteProcessedModelSchedule = /* GraphQL */ `
  subscription OnDeleteProcessedModelSchedule(
    $filter: ModelSubscriptionProcessedModelScheduleFilterInput
    $owner: String
  ) {
    onDeleteProcessedModelSchedule(filter: $filter, owner: $owner) {
      createdAt
      cronExpression
      firstRunTime
      frequency
      id
      lastRunAt
      nextRunAt
      organizationId
      owner
      processedModelSchemaId
      runCount
      status
      timezone
      updatedAt
      __typename
    }
  }
`;
export const onDeleteProcessedModelSchema = /* GraphQL */ `
  subscription OnDeleteProcessedModelSchema(
    $filter: ModelSubscriptionProcessedModelSchemaFilterInput
    $owner: String
  ) {
    onDeleteProcessedModelSchema(filter: $filter, owner: $owner) {
      activeStatus
      createdAt
      dataSources {
        nextToken
        __typename
      }
      deliveryExpectation
      dependency
      description
      executionUrl
      historicalSettings
      id
      isActive
      linkedAssetGroups {
        nextToken
        __typename
      }
      linkedAssets {
        nextToken
        __typename
      }
      linkedDatasets {
        nextToken
        __typename
      }
      linkedOutputs {
        nextToken
        __typename
      }
      modelKind
      name
      organizationId
      outputs {
        nextToken
        __typename
      }
      owner
      runHistory {
        nextToken
        __typename
      }
      runSchedule
      s3BasePath
      schemaFields
      schemaType
      type
      updatedAt
      version
      __typename
    }
  }
`;
export const onDeleteProcessedModelSchemaAssetGroups = /* GraphQL */ `
  subscription OnDeleteProcessedModelSchemaAssetGroups(
    $filter: ModelSubscriptionProcessedModelSchemaAssetGroupsFilterInput
    $owner: String
  ) {
    onDeleteProcessedModelSchemaAssetGroups(filter: $filter, owner: $owner) {
      assetGroup {
        createdAt
        description
        displayedChannels
        id
        name
        organizationId
        owner
        profilePictureUrl
        updatedAt
        userAssetGroupsId
        __typename
      }
      assetGroupID
      createdAt
      id
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaID
      updatedAt
      __typename
    }
  }
`;
export const onDeleteProcessedModelSchemaAssets = /* GraphQL */ `
  subscription OnDeleteProcessedModelSchemaAssets(
    $filter: ModelSubscriptionProcessedModelSchemaAssetsFilterInput
    $owner: String
  ) {
    onDeleteProcessedModelSchemaAssets(filter: $filter, owner: $owner) {
      asset {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      assetID
      createdAt
      id
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaID
      updatedAt
      __typename
    }
  }
`;
export const onDeleteProcessedModelV1EmailLog = /* GraphQL */ `
  subscription OnDeleteProcessedModelV1EmailLog(
    $filter: ModelSubscriptionProcessedModelV1EmailLogFilterInput
  ) {
    onDeleteProcessedModelV1EmailLog(filter: $filter) {
      assetCount
      assetNames
      ccRecipientCount
      chartsRendered
      completedAt
      createdAt
      errorMessage
      id
      recipientCount
      scheduleId
      startedAt
      status
      updatedAt
      __typename
    }
  }
`;
export const onDeleteProcessedModelV1EmailSchedule = /* GraphQL */ `
  subscription OnDeleteProcessedModelV1EmailSchedule(
    $filter: ModelSubscriptionProcessedModelV1EmailScheduleFilterInput
    $owner: String
  ) {
    onDeleteProcessedModelV1EmailSchedule(filter: $filter, owner: $owner) {
      ccRecipients
      createdAt
      cronExpression
      firstRunTime
      frequency
      id
      label
      lastRunAt
      nextRunAt
      organizationId
      owner
      recipients
      runCount
      status
      targets {
        assetId
        assetName
        __typename
      }
      timezone
      updatedAt
      __typename
    }
  }
`;
export const onDeletePublicProfile = /* GraphQL */ `
  subscription OnDeletePublicProfile(
    $filter: ModelSubscriptionPublicProfileFilterInput
    $owner: String
  ) {
    onDeletePublicProfile(filter: $filter, owner: $owner) {
      bio
      createdAt
      displayName
      email
      id
      organizationProfileId
      owner
      profilePictureUrl
      showBio
      showDisplayName
      showEmail
      showProfilePicture
      updatedAt
      __typename
    }
  }
`;
export const onDeleteSolarEnergyModel = /* GraphQL */ `
  subscription OnDeleteSolarEnergyModel(
    $filter: ModelSubscriptionSolarEnergyModelFilterInput
    $owner: String
  ) {
    onDeleteSolarEnergyModel(filter: $filter, owner: $owner) {
      acCap
      arrayAzimuth
      arrayTilt
      createdAt
      dcCap
      description
      groundCoverRatio
      id
      maxTilt
      minIrradiance
      name
      owner
      panelEfficiency
      thermalLoss
      trackingType
      updatedAt
      xUnit
      yUnit
      __typename
    }
  }
`;
export const onDeleteSystemPrompt = /* GraphQL */ `
  subscription OnDeleteSystemPrompt(
    $filter: ModelSubscriptionSystemPromptFilterInput
  ) {
    onDeleteSystemPrompt(filter: $filter) {
      createdAt
      description
      id
      isDefault
      model
      promptText
      rating
      surface
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUploadData = /* GraphQL */ `
  subscription OnDeleteUploadData(
    $filter: ModelSubscriptionUploadDataFilterInput
    $owner: String
  ) {
    onDeleteUploadData(filter: $filter, owner: $owner) {
      createdAt
      description
      fileLocation
      id
      name
      objective
      optimizationHorizon
      owner
      parameter
      seasonality
      temporalResolution
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUser = /* GraphQL */ `
  subscription OnDeleteUser(
    $filter: ModelSubscriptionUserFilterInput
    $username: String
  ) {
    onDeleteUser(filter: $filter, username: $username) {
      assetCount
      assetGroupCount
      assetGroups {
        nextToken
        __typename
      }
      chatPrivacyPolicyAccepted
      chatPrivacyPolicyLocation
      cognitoIdentityId
      createdAt
      email
      geoPoints {
        nextToken
        __typename
      }
      id
      name
      organizationIds
      organizations {
        nextToken
        __typename
      }
      personas {
        nextToken
        __typename
      }
      preferredPersona {
        completed
        createdAt
        description
        id
        markets
        name
        owner
        regions
        selectedNeeds
        summary
        updatedAt
        userId
        __typename
      }
      preferredPersonaId
      privacyPolicyAuditTrail
      profilePictureUrl
      termsAndConditionsAuditTrail
      termsAndConditionsLocation
      termsAndConditionsReviewed
      tourAssetSeen
      tourChatCompleted
      tourGroupSeen
      tourOnboardingGuidanceSent
      tourWelcomeShown
      updatedAt
      userConsent
      username
      __typename
    }
  }
`;
export const onDeleteUserChecklistProgress = /* GraphQL */ `
  subscription OnDeleteUserChecklistProgress(
    $filter: ModelSubscriptionUserChecklistProgressFilterInput
    $owner: String
  ) {
    onDeleteUserChecklistProgress(filter: $filter, owner: $owner) {
      createdAt
      hatUnlocked
      id
      loginDates
      owner
      shippingAddress
      step1Complete
      step2Complete
      step3Complete
      step4Complete
      step5Complete
      step6Complete
      updatedAt
      userId
      welcomeShown
      __typename
    }
  }
`;
export const onDeleteUserOrganizations = /* GraphQL */ `
  subscription OnDeleteUserOrganizations(
    $filter: ModelSubscriptionUserOrganizationsFilterInput
    $owner: String
  ) {
    onDeleteUserOrganizations(filter: $filter, owner: $owner) {
      createdAt
      id
      organization {
        createdAt
        description
        id
        name
        orgAiAnalystAccess
        owner
        profilePictureUrl
        updatedAt
        __typename
      }
      organizationId
      owner
      updatedAt
      user {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      userID
      __typename
    }
  }
`;
export const onDeleteUserPersona = /* GraphQL */ `
  subscription OnDeleteUserPersona(
    $filter: ModelSubscriptionUserPersonaFilterInput
    $owner: String
  ) {
    onDeleteUserPersona(filter: $filter, owner: $owner) {
      completed
      createdAt
      description
      id
      markets
      name
      owner
      regions
      selectedNeeds
      summary
      updatedAt
      user {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      userId
      __typename
    }
  }
`;
export const onDeleteUserProject = /* GraphQL */ `
  subscription OnDeleteUserProject(
    $filter: ModelSubscriptionUserProjectFilterInput
    $owner: String
  ) {
    onDeleteUserProject(filter: $filter, owner: $owner) {
      createdAt
      datasetIds
      description
      id
      imageUrl
      organizationId
      owner
      tasks {
        nextToken
        __typename
      }
      title
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUserProjectTask = /* GraphQL */ `
  subscription OnDeleteUserProjectTask(
    $filter: ModelSubscriptionUserProjectTaskFilterInput
    $owner: String
  ) {
    onDeleteUserProjectTask(filter: $filter, owner: $owner) {
      completedTask
      createdAt
      description
      id
      order
      owner
      project {
        createdAt
        datasetIds
        description
        id
        imageUrl
        organizationId
        owner
        title
        updatedAt
        __typename
      }
      projectId
      title
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUserSubscription = /* GraphQL */ `
  subscription OnDeleteUserSubscription(
    $filter: ModelSubscriptionUserSubscriptionFilterInput
    $owner: String
  ) {
    onDeleteUserSubscription(filter: $filter, owner: $owner) {
      cancelAt
      cancelAtPeriodEnd
      createdAt
      currentPeriodEnd
      customerId
      entitlements
      id
      items
      lastPaymentDate
      lastPaymentStatus
      livemode
      owner
      status
      updatedAt
      __typename
    }
  }
`;
export const onDeleteUserTokenGrant = /* GraphQL */ `
  subscription OnDeleteUserTokenGrant(
    $filter: ModelSubscriptionUserTokenGrantFilterInput
  ) {
    onDeleteUserTokenGrant(filter: $filter) {
      active
      createdAt
      email
      expiresAt
      grantedBy
      id
      notes
      tokenLimit
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAccessRequest = /* GraphQL */ `
  subscription OnUpdateAccessRequest(
    $filter: ModelSubscriptionAccessRequestFilterInput
    $owner: String
  ) {
    onUpdateAccessRequest(filter: $filter, owner: $owner) {
      adminNotes
      createdAt
      description
      email
      id
      owner
      status
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAgentSchedule = /* GraphQL */ `
  subscription OnUpdateAgentSchedule(
    $filter: ModelSubscriptionAgentScheduleFilterInput
    $owner: String
  ) {
    onUpdateAgentSchedule(filter: $filter, owner: $owner) {
      createdAt
      cronExpression
      description
      error
      id
      lastRunAt
      metadata
      nextRunAt
      organizationId
      owner
      projectId
      runCount
      runners {
        nextToken
        __typename
      }
      runs {
        nextToken
        __typename
      }
      runtime
      status
      systemPrompt
      timezone
      title
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAgentScheduleRun = /* GraphQL */ `
  subscription OnUpdateAgentScheduleRun(
    $filter: ModelSubscriptionAgentScheduleRunFilterInput
    $owner: String
  ) {
    onUpdateAgentScheduleRun(filter: $filter, owner: $owner) {
      conversations {
        nextToken
        __typename
      }
      createdAt
      error
      id
      organizationId
      owner
      schedule {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      scheduleId
      status
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAgentScheduleRunner = /* GraphQL */ `
  subscription OnUpdateAgentScheduleRunner(
    $filter: ModelSubscriptionAgentScheduleRunnerFilterInput
    $owner: String
  ) {
    onUpdateAgentScheduleRunner(filter: $filter, owner: $owner) {
      attachments
      conversations {
        nextToken
        __typename
      }
      createdAt
      emailCondition
      emailConditionMode
      id
      organizationId
      owner
      prompt
      schedule {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      scheduleId
      sendEmail
      sortOrder
      title
      updatedAt
      __typename
    }
  }
`;
export const onUpdateAssetGroup = /* GraphQL */ `
  subscription OnUpdateAssetGroup(
    $filter: ModelSubscriptionAssetGroupFilterInput
    $owner: String
  ) {
    onUpdateAssetGroup(filter: $filter, owner: $owner) {
      assets {
        nextToken
        __typename
      }
      createdAt
      description
      displayedChannels
      id
      linkedProcessedModelSchemas {
        nextToken
        __typename
      }
      name
      organizationId
      owner
      profilePictureUrl
      updatedAt
      userAssetGroupsId
      __typename
    }
  }
`;
export const onUpdateComposedForecast = /* GraphQL */ `
  subscription OnUpdateComposedForecast(
    $filter: ModelSubscriptionComposedForecastFilterInput
    $owner: String
  ) {
    onUpdateComposedForecast(filter: $filter, owner: $owner) {
      aggregationMethod
      createdAt
      dataSources {
        nextToken
        __typename
      }
      description
      forecastHorizon
      forecastType
      id
      isActive
      lastProcessed
      linkedAssets {
        nextToken
        __typename
      }
      name
      organizationId
      outputParameters
      owner
      processingSchedule
      updateFrequency
      updatedAt
      validationThresholds
      __typename
    }
  }
`;
export const onUpdateComposedForecastAssets = /* GraphQL */ `
  subscription OnUpdateComposedForecastAssets(
    $filter: ModelSubscriptionComposedForecastAssetsFilterInput
    $owner: String
  ) {
    onUpdateComposedForecastAssets(filter: $filter, owner: $owner) {
      asset {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      assetID
      composedForecast {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      composedForecastID
      createdAt
      icon
      id
      isDefault
      organizationId
      owner
      updatedAt
      __typename
    }
  }
`;
export const onUpdateComposedForecastDataSource = /* GraphQL */ `
  subscription OnUpdateComposedForecastDataSource(
    $filter: ModelSubscriptionComposedForecastDataSourceFilterInput
    $owner: String
  ) {
    onUpdateComposedForecastDataSource(filter: $filter, owner: $owner) {
      composedForecast {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      composedForecastId
      createdAt
      dataOperations
      dataQualityScore
      externalApiEndpoint
      externalApiHeaders
      externalApiKey
      externalApiParams
      fallbackStrategy
      fallbackValue
      fetchErrorMessage
      groundTruthSensorId
      groundTruthTableName
      id
      isActive
      lastFetchStatus
      lastFetchedAt
      metadata
      modelOutputTimeOffset
      organizationId
      owner
      postgresAggregation
      postgresColumns
      postgresQuery
      postgresTable
      postgresTimeRange
      priority
      processedModelOutput {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      processedModelOutputId
      projectId
      s3FileFormat
      s3Location
      s3ParseConfig
      sourceDescription
      sourceName
      sourceType
      temporalResolution
      timeAlignment
      timeLag
      transformations
      updatedAt
      validationRules
      weight
      zarrCoordinates
      zarrPath
      zarrTimeSelection
      zarrVariable
      __typename
    }
  }
`;
export const onUpdateDataSetRecord = /* GraphQL */ `
  subscription OnUpdateDataSetRecord(
    $filter: ModelSubscriptionDataSetRecordFilterInput
    $owner: String
  ) {
    onUpdateDataSetRecord(filter: $filter, owner: $owner) {
      columns
      compressedSize
      compressionType
      createdAt
      dataset {
        columns
        createdAt
        curationMode
        datasetType
        deletedAt
        description
        duplicatePolicy
        fileFormat
        fileSize
        id
        ingestMetadata
        lastUpdated
        linkedAssets
        linkedSchemas
        location
        locationId
        name
        organizationId
        owner
        parameterType
        profilePictureUrl
        recordCount
        routeLong
        slug
        sourceModelId
        tags
        timeRange
        units
        updateFrequency
        updatedAt
        userId
        __typename
      }
      datasetId
      fileName
      fileSize
      id
      organizationId
      owner
      recordCount
      s3Path
      timeRange
      timeValue
      updatedAt
      uploadId
      uploadedAt
      uploadedBy
      uploadedByEmail
      __typename
    }
  }
`;
export const onUpdateDataSource = /* GraphQL */ `
  subscription OnUpdateDataSource(
    $filter: ModelSubscriptionDataSourceFilterInput
    $owner: String
  ) {
    onUpdateDataSource(filter: $filter, owner: $owner) {
      createdAt
      dataOperations
      databaseTable
      format
      id
      isGroundTruth
      metadata
      name
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaId
      s3Path
      sourceType
      updatedAt
      __typename
    }
  }
`;
export const onUpdateDataset = /* GraphQL */ `
  subscription OnUpdateDataset(
    $filter: ModelSubscriptionDatasetFilterInput
    $owner: String
  ) {
    onUpdateDataset(filter: $filter, owner: $owner) {
      columns
      createdAt
      curationMode
      datasetType
      deletedAt
      description
      duplicatePolicy
      fileFormat
      fileSize
      id
      ingestMetadata
      lastUpdated
      linkedAssets
      linkedSchemas
      location
      locationId
      name
      organizationId
      owner
      parameterType
      profilePictureUrl
      recordCount
      records {
        nextToken
        __typename
      }
      routeLong
      slug
      sourceModelId
      tags
      timeRange
      units
      updateFrequency
      updatedAt
      userId
      __typename
    }
  }
`;
export const onUpdateDatasetUpload = /* GraphQL */ `
  subscription OnUpdateDatasetUpload(
    $filter: ModelSubscriptionDatasetUploadFilterInput
    $owner: String
  ) {
    onUpdateDatasetUpload(filter: $filter, owner: $owner) {
      columnMetadata
      columnSources
      columns
      createdAt
      datasetId
      duplicateTimestamps
      failureReason
      fileName
      id
      incomingKey
      inputsReadAt
      organizationId
      outputParamId
      owner
      processedAt
      processedModelSchemaId
      rawKey
      receivedAt
      recordId
      rejectedKey
      requestedAt
      rowCount
      runId
      sizeBytes
      source
      sourceTimezone
      status
      timeRange
      updatedAt
      uploadedBy
      uploadedByEmail
      validationErrors
      warnings
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const onUpdateErrorLog = /* GraphQL */ `
  subscription OnUpdateErrorLog(
    $filter: ModelSubscriptionErrorLogFilterInput
    $owner: String
  ) {
    onUpdateErrorLog(filter: $filter, owner: $owner) {
      adminNotes
      cognitoIdentityId
      createdAt
      description
      id
      images
      mcpConversationId
      mcpMessageId
      owner
      pageUrl
      source
      status
      updatedAt
      userEmail
      __typename
    }
  }
`;
export const onUpdateForecastRecord = /* GraphQL */ `
  subscription OnUpdateForecastRecord(
    $filter: ModelSubscriptionForecastRecordFilterInput
    $owner: String
  ) {
    onUpdateForecastRecord(filter: $filter, owner: $owner) {
      createdAt
      forecastIssued
      id
      inputs
      metadata
      organizationId
      owner
      parameter {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      parameterId
      run {
        acknowledged
        acknowledgedAt
        acknowledgedBy
        attempt
        completedAt
        createdAt
        description
        executionTimeMs
        id
        inputs
        modelSchemaTemplateId
        organizationId
        outputS3Keys
        owner
        processedModelScheduleId
        processedModelSchemaId
        requestId
        startedAt
        status
        triggerType
        updatedAt
        windowEnd
        windowStart
        __typename
      }
      runId
      s3Key
      seriesEnd
      seriesMetaData
      seriesStart
      source
      updatedAt
      uploadId
      uploadedBy
      __typename
    }
  }
`;
export const onUpdateForecastReport = /* GraphQL */ `
  subscription OnUpdateForecastReport(
    $filter: ModelSubscriptionForecastReportFilterInput
    $owner: String
  ) {
    onUpdateForecastReport(filter: $filter, owner: $owner) {
      completedAt
      config
      createdAt
      description
      error
      id
      identityId
      name
      organizationId
      owner
      progress
      resultS3Key
      startedAt
      status
      summary
      updatedAt
      __typename
    }
  }
`;
export const onUpdateForecastUpload = /* GraphQL */ `
  subscription OnUpdateForecastUpload(
    $filter: ModelSubscriptionForecastUploadFilterInput
    $owner: String
  ) {
    onUpdateForecastUpload(filter: $filter, owner: $owner) {
      createdAt
      failureReason
      fileName
      finalKey
      forecastIssued
      forecastRecordId
      id
      incomingKey
      issueTime
      organizationId
      outputParamId
      owner
      parameters
      processedAt
      rawKey
      receivedAt
      requestedAt
      rowCount
      schemaId
      sizeBytes
      source
      status
      timeRange
      updatedAt
      uploadedBy
      uploadedByEmail
      validationErrors
      warnings
      __typename
    }
  }
`;
export const onUpdateGeoPoint = /* GraphQL */ `
  subscription OnUpdateGeoPoint(
    $filter: ModelSubscriptionGeoPointFilterInput
    $owner: String
  ) {
    onUpdateGeoPoint(filter: $filter, owner: $owner) {
      assetGroupId
      client
      createdAt
      description
      displayedChannels
      elevation
      geojson
      icon
      id
      imageUrl
      lat
      linkedComposedForecasts {
        nextToken
        __typename
      }
      linkedProcessedModelSchemas {
        nextToken
        __typename
      }
      lng
      name
      organizationId
      owner
      precipCurve {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      precipCurveId
      processedModels {
        nextToken
        __typename
      }
      solarCurve {
        acCap
        arrayAzimuth
        arrayTilt
        createdAt
        dcCap
        description
        groundCoverRatio
        id
        maxTilt
        minIrradiance
        name
        owner
        panelEfficiency
        thermalLoss
        trackingType
        updatedAt
        xUnit
        yUnit
        __typename
      }
      solarCurveId
      tags
      updatedAt
      userGeoPointsId
      value {
        currency
        value
        __typename
      }
      windCurve {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      windCurveId
      __typename
    }
  }
`;
export const onUpdateLlmResponse = /* GraphQL */ `
  subscription OnUpdateLlmResponse(
    $filter: ModelSubscriptionLlmResponseFilterInput
    $owner: String
  ) {
    onUpdateLlmResponse(filter: $filter, owner: $owner) {
      conversation
      createdAt
      description
      executionTime
      id
      owner
      queryType
      response
      updatedAt
      uploadURL
      __typename
    }
  }
`;
export const onUpdateLoginAccessCodes = /* GraphQL */ `
  subscription OnUpdateLoginAccessCodes(
    $filter: ModelSubscriptionLoginAccessCodesFilterInput
  ) {
    onUpdateLoginAccessCodes(filter: $filter) {
      activatedBy
      available
      code
      createdAt
      notes
      recipient
      updatedAt
      __typename
    }
  }
`;
export const onUpdateMCPConversation = /* GraphQL */ `
  subscription OnUpdateMCPConversation(
    $filter: ModelSubscriptionMCPConversationFilterInput
    $owner: String
  ) {
    onUpdateMCPConversation(filter: $filter, owner: $owner) {
      agentScheduleRunId
      agentScheduleRunnerId
      conversationType
      createdAt
      id
      isActive
      lastMessageAt
      messageCount
      messages {
        nextToken
        __typename
      }
      metadata
      model
      modelCodename
      organizationId
      owner
      projectId
      projectTaskId
      title
      totalTokens
      unreadCount
      updatedAt
      __typename
    }
  }
`;
export const onUpdateMCPMessage = /* GraphQL */ `
  subscription OnUpdateMCPMessage(
    $filter: ModelSubscriptionMCPMessageFilterInput
    $owner: String
  ) {
    onUpdateMCPMessage(filter: $filter, owner: $owner) {
      attachments
      content
      conversation {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      conversationId
      createdAt
      enhancedPrompt
      executionTimeMs
      id
      inputTokens
      isUser
      messageRead
      model
      modelCodename
      organizationId
      outputTokens
      owner
      rating
      ratingComment
      rounds
      serverId
      sessionId
      status
      toolsCount
      updatedAt
      __typename
    }
  }
`;
export const onUpdateMCPMessageAll = /* GraphQL */ `
  subscription OnUpdateMCPMessageAll {
    onUpdateMCPMessageAll {
      attachments
      content
      conversation {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      conversationId
      createdAt
      enhancedPrompt
      executionTimeMs
      id
      inputTokens
      isUser
      messageRead
      model
      modelCodename
      organizationId
      outputTokens
      owner
      rating
      ratingComment
      rounds
      serverId
      sessionId
      status
      toolsCount
      updatedAt
      __typename
    }
  }
`;
export const onUpdateMCPSharedConversation = /* GraphQL */ `
  subscription OnUpdateMCPSharedConversation(
    $filter: ModelSubscriptionMCPSharedConversationFilterInput
    $owner: String
  ) {
    onUpdateMCPSharedConversation(filter: $filter, owner: $owner) {
      conversationId
      conversationType
      createdAt
      id
      includePrompts
      isActive
      messageId
      organizationId
      owner
      s3Key
      scheduleRunnerId
      scope
      title
      updatedAt
      __typename
    }
  }
`;
export const onUpdateMCPUsage = /* GraphQL */ `
  subscription OnUpdateMCPUsage(
    $filter: ModelSubscriptionMCPUsageFilterInput
    $userId: String
  ) {
    onUpdateMCPUsage(filter: $filter, userId: $userId) {
      createdAt
      id
      period
      requestCount
      subscriptionTier
      tokenLimit
      tokensUsed
      updatedAt
      userId
      __typename
    }
  }
`;
export const onUpdateModelSchemaTemplate = /* GraphQL */ `
  subscription OnUpdateModelSchemaTemplate(
    $filter: ModelSubscriptionModelSchemaTemplateFilterInput
  ) {
    onUpdateModelSchemaTemplate(filter: $filter) {
      authorProfileId
      authorType
      category
      createdAt
      createdBy
      description
      executionUrl
      external
      fieldDefinitions
      historicalConfig
      id
      isActive
      modelKind
      name
      profilePictureUrl
      requiresTraining
      tags
      trainingCost
      updatedAt
      version
      __typename
    }
  }
`;
export const onUpdateOrganization = /* GraphQL */ `
  subscription OnUpdateOrganization(
    $filter: ModelSubscriptionOrganizationFilterInput
    $owner: String
  ) {
    onUpdateOrganization(filter: $filter, owner: $owner) {
      createdAt
      description
      id
      members {
        nextToken
        __typename
      }
      name
      orgAiAnalystAccess
      owner
      profilePictureUrl
      updatedAt
      __typename
    }
  }
`;
export const onUpdateOrganizationPublicProfile = /* GraphQL */ `
  subscription OnUpdateOrganizationPublicProfile(
    $filter: ModelSubscriptionOrganizationPublicProfileFilterInput
    $owner: String
  ) {
    onUpdateOrganizationPublicProfile(filter: $filter, owner: $owner) {
      bio
      createdAt
      displayName
      email
      employees {
        nextToken
        __typename
      }
      id
      owner
      profilePictureUrl
      showBio
      showDisplayName
      showEmail
      showProfilePicture
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePerformanceCurve = /* GraphQL */ `
  subscription OnUpdatePerformanceCurve(
    $filter: ModelSubscriptionPerformanceCurveFilterInput
    $owner: String
  ) {
    onUpdatePerformanceCurve(filter: $filter, owner: $owner) {
      createdAt
      curveData {
        x
        y
        __typename
      }
      description
      id
      name
      organizationId
      organizationIds
      owner
      updatedAt
      xUnit
      yUnit
      __typename
    }
  }
`;
export const onUpdateProcessedModel = /* GraphQL */ `
  subscription OnUpdateProcessedModel(
    $filter: ModelSubscriptionProcessedModelFilterInput
    $owner: String
  ) {
    onUpdateProcessedModel(filter: $filter, owner: $owner) {
      additionalDataPoints {
        color
        id
        lookbackDays
        name
        parameterId
        schema
        source
        __typename
      }
      assetId
      createdAt
      deliveryCron
      deliveryGraceMinutes
      deliveryMatchBy
      deliveryTimezone
      deliveryTrackingStartedAt
      description
      displayType
      geopoint {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      id
      label
      modelType
      organizationId
      owner
      routeLong
      routeShort
      schema
      updatedAt
      __typename
    }
  }
`;
export const onUpdateProcessedModelOutputParam = /* GraphQL */ `
  subscription OnUpdateProcessedModelOutputParam(
    $filter: ModelSubscriptionProcessedModelOutputParamFilterInput
    $owner: String
  ) {
    onUpdateProcessedModelOutputParam(filter: $filter, owner: $owner) {
      active
      channels
      createdAt
      description
      forecasts {
        nextToken
        __typename
      }
      id
      name
      organizationId
      outputLocation
      owner
      parameterTypeId
      schema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      schemaId
      seriesMetaData
      storageMode
      targetDatasetId
      unit
      updatedAt
      __typename
    }
  }
`;
export const onUpdateProcessedModelRunHistory = /* GraphQL */ `
  subscription OnUpdateProcessedModelRunHistory(
    $filter: ModelSubscriptionProcessedModelRunHistoryFilterInput
    $owner: String
  ) {
    onUpdateProcessedModelRunHistory(filter: $filter, owner: $owner) {
      acknowledged
      acknowledgedAt
      acknowledgedBy
      attempt
      completedAt
      createdAt
      description
      executionTimeMs
      forecasts {
        nextToken
        __typename
      }
      id
      inputs
      modelSchemaTemplateId
      organizationId
      outputS3Keys
      owner
      processedModelScheduleId
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaId
      requestId
      startedAt
      status
      triggerType
      updatedAt
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const onUpdateProcessedModelRunRequest = /* GraphQL */ `
  subscription OnUpdateProcessedModelRunRequest(
    $filter: ModelSubscriptionProcessedModelRunRequestFilterInput
    $owner: String
  ) {
    onUpdateProcessedModelRunRequest(filter: $filter, owner: $owner) {
      attempts
      backfillId
      chunkCount
      chunkIndex
      completedAt
      createdAt
      error
      id
      mergedInto
      notBefore
      organizationId
      owner
      processedModelSchemaId
      runIds
      startedAt
      status
      triggerRef
      triggerType
      updatedAt
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const onUpdateProcessedModelSchedule = /* GraphQL */ `
  subscription OnUpdateProcessedModelSchedule(
    $filter: ModelSubscriptionProcessedModelScheduleFilterInput
    $owner: String
  ) {
    onUpdateProcessedModelSchedule(filter: $filter, owner: $owner) {
      createdAt
      cronExpression
      firstRunTime
      frequency
      id
      lastRunAt
      nextRunAt
      organizationId
      owner
      processedModelSchemaId
      runCount
      status
      timezone
      updatedAt
      __typename
    }
  }
`;
export const onUpdateProcessedModelSchema = /* GraphQL */ `
  subscription OnUpdateProcessedModelSchema(
    $filter: ModelSubscriptionProcessedModelSchemaFilterInput
    $owner: String
  ) {
    onUpdateProcessedModelSchema(filter: $filter, owner: $owner) {
      activeStatus
      createdAt
      dataSources {
        nextToken
        __typename
      }
      deliveryExpectation
      dependency
      description
      executionUrl
      historicalSettings
      id
      isActive
      linkedAssetGroups {
        nextToken
        __typename
      }
      linkedAssets {
        nextToken
        __typename
      }
      linkedDatasets {
        nextToken
        __typename
      }
      linkedOutputs {
        nextToken
        __typename
      }
      modelKind
      name
      organizationId
      outputs {
        nextToken
        __typename
      }
      owner
      runHistory {
        nextToken
        __typename
      }
      runSchedule
      s3BasePath
      schemaFields
      schemaType
      type
      updatedAt
      version
      __typename
    }
  }
`;
export const onUpdateProcessedModelSchemaAssetGroups = /* GraphQL */ `
  subscription OnUpdateProcessedModelSchemaAssetGroups(
    $filter: ModelSubscriptionProcessedModelSchemaAssetGroupsFilterInput
    $owner: String
  ) {
    onUpdateProcessedModelSchemaAssetGroups(filter: $filter, owner: $owner) {
      assetGroup {
        createdAt
        description
        displayedChannels
        id
        name
        organizationId
        owner
        profilePictureUrl
        updatedAt
        userAssetGroupsId
        __typename
      }
      assetGroupID
      createdAt
      id
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaID
      updatedAt
      __typename
    }
  }
`;
export const onUpdateProcessedModelSchemaAssets = /* GraphQL */ `
  subscription OnUpdateProcessedModelSchemaAssets(
    $filter: ModelSubscriptionProcessedModelSchemaAssetsFilterInput
    $owner: String
  ) {
    onUpdateProcessedModelSchemaAssets(filter: $filter, owner: $owner) {
      asset {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      assetID
      createdAt
      id
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaID
      updatedAt
      __typename
    }
  }
`;
export const onUpdateProcessedModelV1EmailLog = /* GraphQL */ `
  subscription OnUpdateProcessedModelV1EmailLog(
    $filter: ModelSubscriptionProcessedModelV1EmailLogFilterInput
  ) {
    onUpdateProcessedModelV1EmailLog(filter: $filter) {
      assetCount
      assetNames
      ccRecipientCount
      chartsRendered
      completedAt
      createdAt
      errorMessage
      id
      recipientCount
      scheduleId
      startedAt
      status
      updatedAt
      __typename
    }
  }
`;
export const onUpdateProcessedModelV1EmailSchedule = /* GraphQL */ `
  subscription OnUpdateProcessedModelV1EmailSchedule(
    $filter: ModelSubscriptionProcessedModelV1EmailScheduleFilterInput
    $owner: String
  ) {
    onUpdateProcessedModelV1EmailSchedule(filter: $filter, owner: $owner) {
      ccRecipients
      createdAt
      cronExpression
      firstRunTime
      frequency
      id
      label
      lastRunAt
      nextRunAt
      organizationId
      owner
      recipients
      runCount
      status
      targets {
        assetId
        assetName
        __typename
      }
      timezone
      updatedAt
      __typename
    }
  }
`;
export const onUpdatePublicProfile = /* GraphQL */ `
  subscription OnUpdatePublicProfile(
    $filter: ModelSubscriptionPublicProfileFilterInput
    $owner: String
  ) {
    onUpdatePublicProfile(filter: $filter, owner: $owner) {
      bio
      createdAt
      displayName
      email
      id
      organizationProfileId
      owner
      profilePictureUrl
      showBio
      showDisplayName
      showEmail
      showProfilePicture
      updatedAt
      __typename
    }
  }
`;
export const onUpdateSolarEnergyModel = /* GraphQL */ `
  subscription OnUpdateSolarEnergyModel(
    $filter: ModelSubscriptionSolarEnergyModelFilterInput
    $owner: String
  ) {
    onUpdateSolarEnergyModel(filter: $filter, owner: $owner) {
      acCap
      arrayAzimuth
      arrayTilt
      createdAt
      dcCap
      description
      groundCoverRatio
      id
      maxTilt
      minIrradiance
      name
      owner
      panelEfficiency
      thermalLoss
      trackingType
      updatedAt
      xUnit
      yUnit
      __typename
    }
  }
`;
export const onUpdateSystemPrompt = /* GraphQL */ `
  subscription OnUpdateSystemPrompt(
    $filter: ModelSubscriptionSystemPromptFilterInput
  ) {
    onUpdateSystemPrompt(filter: $filter) {
      createdAt
      description
      id
      isDefault
      model
      promptText
      rating
      surface
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUploadData = /* GraphQL */ `
  subscription OnUpdateUploadData(
    $filter: ModelSubscriptionUploadDataFilterInput
    $owner: String
  ) {
    onUpdateUploadData(filter: $filter, owner: $owner) {
      createdAt
      description
      fileLocation
      id
      name
      objective
      optimizationHorizon
      owner
      parameter
      seasonality
      temporalResolution
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUser = /* GraphQL */ `
  subscription OnUpdateUser(
    $filter: ModelSubscriptionUserFilterInput
    $username: String
  ) {
    onUpdateUser(filter: $filter, username: $username) {
      assetCount
      assetGroupCount
      assetGroups {
        nextToken
        __typename
      }
      chatPrivacyPolicyAccepted
      chatPrivacyPolicyLocation
      cognitoIdentityId
      createdAt
      email
      geoPoints {
        nextToken
        __typename
      }
      id
      name
      organizationIds
      organizations {
        nextToken
        __typename
      }
      personas {
        nextToken
        __typename
      }
      preferredPersona {
        completed
        createdAt
        description
        id
        markets
        name
        owner
        regions
        selectedNeeds
        summary
        updatedAt
        userId
        __typename
      }
      preferredPersonaId
      privacyPolicyAuditTrail
      profilePictureUrl
      termsAndConditionsAuditTrail
      termsAndConditionsLocation
      termsAndConditionsReviewed
      tourAssetSeen
      tourChatCompleted
      tourGroupSeen
      tourOnboardingGuidanceSent
      tourWelcomeShown
      updatedAt
      userConsent
      username
      __typename
    }
  }
`;
export const onUpdateUserChecklistProgress = /* GraphQL */ `
  subscription OnUpdateUserChecklistProgress(
    $filter: ModelSubscriptionUserChecklistProgressFilterInput
    $owner: String
  ) {
    onUpdateUserChecklistProgress(filter: $filter, owner: $owner) {
      createdAt
      hatUnlocked
      id
      loginDates
      owner
      shippingAddress
      step1Complete
      step2Complete
      step3Complete
      step4Complete
      step5Complete
      step6Complete
      updatedAt
      userId
      welcomeShown
      __typename
    }
  }
`;
export const onUpdateUserOrganizations = /* GraphQL */ `
  subscription OnUpdateUserOrganizations(
    $filter: ModelSubscriptionUserOrganizationsFilterInput
    $owner: String
  ) {
    onUpdateUserOrganizations(filter: $filter, owner: $owner) {
      createdAt
      id
      organization {
        createdAt
        description
        id
        name
        orgAiAnalystAccess
        owner
        profilePictureUrl
        updatedAt
        __typename
      }
      organizationId
      owner
      updatedAt
      user {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      userID
      __typename
    }
  }
`;
export const onUpdateUserPersona = /* GraphQL */ `
  subscription OnUpdateUserPersona(
    $filter: ModelSubscriptionUserPersonaFilterInput
    $owner: String
  ) {
    onUpdateUserPersona(filter: $filter, owner: $owner) {
      completed
      createdAt
      description
      id
      markets
      name
      owner
      regions
      selectedNeeds
      summary
      updatedAt
      user {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      userId
      __typename
    }
  }
`;
export const onUpdateUserProject = /* GraphQL */ `
  subscription OnUpdateUserProject(
    $filter: ModelSubscriptionUserProjectFilterInput
    $owner: String
  ) {
    onUpdateUserProject(filter: $filter, owner: $owner) {
      createdAt
      datasetIds
      description
      id
      imageUrl
      organizationId
      owner
      tasks {
        nextToken
        __typename
      }
      title
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUserProjectTask = /* GraphQL */ `
  subscription OnUpdateUserProjectTask(
    $filter: ModelSubscriptionUserProjectTaskFilterInput
    $owner: String
  ) {
    onUpdateUserProjectTask(filter: $filter, owner: $owner) {
      completedTask
      createdAt
      description
      id
      order
      owner
      project {
        createdAt
        datasetIds
        description
        id
        imageUrl
        organizationId
        owner
        title
        updatedAt
        __typename
      }
      projectId
      title
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUserSubscription = /* GraphQL */ `
  subscription OnUpdateUserSubscription(
    $filter: ModelSubscriptionUserSubscriptionFilterInput
    $owner: String
  ) {
    onUpdateUserSubscription(filter: $filter, owner: $owner) {
      cancelAt
      cancelAtPeriodEnd
      createdAt
      currentPeriodEnd
      customerId
      entitlements
      id
      items
      lastPaymentDate
      lastPaymentStatus
      livemode
      owner
      status
      updatedAt
      __typename
    }
  }
`;
export const onUpdateUserTokenGrant = /* GraphQL */ `
  subscription OnUpdateUserTokenGrant(
    $filter: ModelSubscriptionUserTokenGrantFilterInput
  ) {
    onUpdateUserTokenGrant(filter: $filter) {
      active
      createdAt
      email
      expiresAt
      grantedBy
      id
      notes
      tokenLimit
      updatedAt
      __typename
    }
  }
`;
